import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';


@Injectable()
export class TitleService {
    title: string = "{Title} - IdentityService Front Office";

    constructor(private titleService: Title) {
        
    }

    public setTitle(title: string) {
        this.titleService.setTitle(this.title.replace('{Title}', title));
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/services/common/title.service.ts